export const ModelList = [
    {
        'group':'Matala Gold',
        'name':'Models',
        'models':
        [
            {name:'Surface	',url:'./models/surface.glb'},
            {name:'Pit',url:'./models/pit.glb'},
            {name:'Mineralization',url:'./models/mineralization.glb'},
            {name:'Topo1m',url:'./models/topo1m.glb'},
            {name:'Underground',url:'./models/underground.glb'},
        ]
    },
    {
        group:'Holes',
        name:'Holes',
        models:[
            {type:'holesassays',name:'Holes',assay_url:'./files/LH_Assay.csv',hole_url:'./files/LH_Collar.csv' },
        ]
    },

    
]